module.exports = __webpack_public_path__ + "img/Anavil_Sirop_1280x1010.fa223e8e.jpg";